import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  justify-content: center;
  padding: 50px 20px;
`;

export const Content = styled.div`
  max-width: 1240px;
  width: 100%;

  h1 {
    color: #1a3458;
    font-size: 48px;
    margin-bottom: 61px;
  }

  > div {
    display: flex;
    gap: 37px;
    justify-content: center;

    @media (max-width: 1024px) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      justify-items: center;
      width: 100%;
    }

    @media (max-width: 510px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  @media (max-width: 425px) {
    h1 {
      font-size: 25px;
    }
  }
`;

export const Album = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 215px;
  align-items: center;
  border: none;
  cursor: pointer;

  img {
    width: 100%;
    height: 164px;
  }

  span {
    font-size: 21px;
    color: #1a3458;
    text-align: center;
  }
`;
